<!--<div (click)="showOverviewModal=true">Click me</div> -->
<!--<app-modal [showModal]='showOverviewModal'  id="reportpopup">-->

    <div  aria-labelledby="modalHeading" class="report-request-modal" *ngIf='showOverviewModal' (keydown)="handleKeydown($event)">
        {{loadFocuselements()}}
        <div class="modal-header" *ngIf="!showNew && !showNewMI">
            <h2 id='modalHeading' tabindex="0">Request report </h2>
        </div>
        <div class="modal-header" *ngIf="showNew || showNewMI">
            <h2 id='modalHeading' tabindex="0">Generate Inventory Report </h2>
        </div>
        <!-- <div class="error-message" *ngIf="showError">
            <div class="left"> -->
                <!--//Alert?-->
                <!-- <img src="assets/img/Icon-cross.png" alt="Alert">
            </div>
            <div class="right">
                Something went wrong. We couldn't process your request. Please try again later.
            </div>
        </div> -->
        
        <div *ngIf="showError" class="alert alertReport valign-children-middle error-container" >
            <div class="alert-error" role="img">
              <i class="icon-badgealert" aria-label="alert"></i>
            </div>
            <div>Something went wrong. We couldn't process your request. Please try again later.</div>
        </div>

        <div class="corner-button">
            <button id="closeBtn" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModalPopup(false)" (keydown)="closeModalPopup(false,$event)"  >x</button>
        </div>
        <div class="box-outer">
            <div class="description"  *ngIf="!showError && (!showNew && !showNewMI)">
                Select the type of report and the report format. We’ll email you the report.
            </div>
            <div class="description"  *ngIf="!showError && (showNew || showNewMI) ">
                Select the report format you prefer. We’ll email you the report.
            </div>
            
            <br>
      
            <div *ngIf= "!showNew && !showNewMI" class="sub-header" title="Select report type"> Select report type</div>
            <div *ngIf= "!showNew && !showNewMI" class="radio">
                    
                 <input #devicereport type="radio" id="device_report" value="Device status" aria-label="Device Status under report type" name="type" [(ngModel)]="report.type" >
                   <i class="skin" (click)="devicereport.click()"></i>
                   <label for="device_report"> 
                       <span>Device status</span>
                   </label>
          </div>
            <div *ngIf= "!showNew && !showNewMI" class="radio">

                     <input #accountactivity type="radio" id="accountactivity_report" aria-label="Account activity under report type" value="Transaction history" name="type" [(ngModel)]="report.type" >
                      <i class="skin" (click)="accountactivity.click()"></i>
                      <label for="accountactivity_report"> 
                      <span>Account activity</span>
                      </label>
                      </div>
                      

   
            <div class="sub-header" *ngIf= "!showNew && !showNewMI" title="Select report format"> Select report format</div>
            <div class="sub-header" *ngIf= "showNew || showNewMI" title="Report Format"><strong> Report Format</strong></div>
            <div class="radio">

                     <input #excel  type="radio"  id="excel_format" value="Excel (XLS)" aria-label="Excel (XLS) under report format" name="format" [(ngModel)]="report.format" (blur)= "setFocus('pdf_format',$event)" >
                     <i class="skin" (click)="excel.click()" ></i>
                     <label for="excel_format">
                     <span> Excel (XLS)</span>
                     </label>
                  </div>
            <div class="radio">
        
                    <input #pdf  type="radio"  id="pdf_format" value="PDF" aria-label="PDF under report format" name="format" [(ngModel)]="report.format" (keydown)= "setFocus('report-request-btn',$event)" >
                    <i class="skin" (click)="pdf.click()" ></i>
                    <label for="pdf_format">
                    <span>PDF</span>
                    </label>
                 </div>
  
        </div>
        <div class="text-right modal-footer">
            <div *ngIf= "!showNew && !showNewMI" class="button-group">
                <!--<a href="javascript:void(0)" role="button" class="btn btn-secondary pull-right" (click)="btnAction(true)" attr.aria-label="Continue">Continue</a>-->
                <button id="report-request-btn" [checkImpersonator]="!report.type || !report.format"  (click)="btnAction(true)" class="btn btn-secondary pull-right" attr.aria-label="Continue">Request report</button>
                <a href="javascript:void(0)" class="btn btn-link cancel-button-modal" (click)="closeModalPopup(false)" attr.aria-label="Cancel">Cancel</a>
            </div>
            <div *ngIf= "showNew || showNewMI" class="button-group">
                <!--<a href="javascript:void(0)" role="button" class="btn btn-secondary pull-right" (click)="btnAction(true)" attr.aria-label="Continue">Continue</a>-->
                <button id="report-request-btn" [checkImpersonator]="!report.format"  (click)="btnAction(true)"  (keydown)="btnAction(true, $event)" class="btn btn-secondary pull-right" attr.aria-label="Continue"  (blur)= "setFocus('closeBtn')">Submit request </button>
                <!-- <a href="javascript:void(0)" class="btn btn-link cancel-button-modal" (click)="closeModalPopup(false)" attr.aria-label="Cancel">Cancel</a> -->
            </div>
            <div class="clearfix"></div>
        </div>
    </div>

<!--</app-modal>-->

<div *ngIf="showSuccess" aria-label="Report Request Status">

    <app-report-success [modalPopupObject]='overviewModalPopup' [triggerElement]='eventEmit' (modalOutput)='closeModalPopup(true)'>
    </app-report-success>

</div>

<router-outlet></router-outlet>
